import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { asyncForEach, round, validateStatusOrders } from '@/utils';
import lodash from 'lodash';
import moment from 'moment-timezone';
import * as XLSX from 'xlsx';

async function fillOrderStore(order: any) {
    if (!order || order.store_name) return;
    if (order.logistic_type === 'cotizador' || order.logistic_type === 'ecommerce') return;
    try {
        const res = await directusApi('GET', `custom/legacy-mercadolibre/orders/${order.id}/store`);
        if (res.data?.store) order.store = res.data.store;
        if (res.data?.store_name) order.store_name = res.data.store_name;
    } catch (err) {
        console.log(err);
    }
}
export interface Order {
    id?: number;
    title: string;
    order_date: string;
    intelisis_movement: string;
    logistic_type: string;
    total_amount: number;
    shipping_cost: number;
    status: string;
    balance: number;
    entry_amount: number;
    document_amount: number;
    comments: string;
    total_charges: number;
    order_status: string;
    credit_note: string;
    package_manager: string;
    printed_label: boolean;
}

// export interface PublicationDTO {
//     title: string;
// }

export interface OrderState {
    activeOrder: Order | null;
    activeOrderLoading: boolean;

    allOrders: Array<Order>;
    allOrdersLoading: boolean;
    monthlySummary: boolean;
    ordersPerPage: number;
    ordersPage: number;
    ordersTotal: number;

    ordersSchedule: any;
}

const state: OrderState = {
    activeOrder: {
        id: 0,
        title: '',
        order_date: '',
        intelisis_movement: '',
        logistic_type: '',
        total_amount: 0,
        shipping_cost: 0,
        status: '',
        balance: 0,
        entry_amount: 0,
        document_amount: 0,
        comments: '',
        total_charges: 0,
        order_status: '',
        credit_note: '',
        package_manager: '',
        printed_label: false
    },
    activeOrderLoading: false,

    allOrders: [],
    allOrdersLoading: false,
    ordersPerPage: 1,
    ordersPage: 1,
    ordersTotal: 1,
    ordersSchedule: [],
    monthlySummary: false
};

const mutations = {
    toggleallOrdersLoading(state: OrderState, data: boolean) {
        state.allOrdersLoading = data;
    },
    setAllOrders(state: OrderState, data: PaginatedCollection) {
        state.allOrders = data.items;
        state.ordersPerPage = data.perPage;
        state.ordersPage = data.currentPage;
        state.ordersTotal = data.totalItems;
    },
    toggleActiveOrderLoading(state: OrderState, data: boolean) {
        state.activeOrderLoading = data;
    },
    setActiveOrder(state: OrderState, data: Order) {
        // let allOrders = [data, ...state.allOrders];
        // state.allOrders = lodash.uniqBy(allOrders, 'id');
        // state.activeOrder = data;

        // state.allOrders.forEach(order => {
        //     if (order.id == data.id) {
        //         order.comments = data.comments;
        //         order.package_manager = data.package_manager;
        //     }
        // });
        let allOrders = state.allOrders.map((order: any) => {
            if (order.id == data.id) {
                order.intelisis_movement = data.intelisis_movement;
                order.credit_note = data.credit_note;
                order.package_manager = data.package_manager;

                order.comments = data.comments;
            }
            // order = data;
            return order
        });
        // 5089247457 order test (comments)
        // let allOrders = [data, ...state.allOrders];
        state.allOrders = lodash.uniqBy(allOrders, 'id');
        state.activeOrder = data;
        // console.log('setActiveOrder', state.activeOrder);
    },
    setOrdersSchedule(state: OrderState, data: any) {
        state.ordersSchedule = data;
    },
    monthlySummaryLoading(state: OrderState, data: boolean) {
        state.monthlySummary = data;
    },
};

const actions = {
    async putOne({ _, commit, dispatch }: any, data: any) {
        let order_id: any = data.id;
        // console.log('order to update => ', data);
        // commit('toggleActiveOrderLoading', true);

        if (data.intelisis_movement) {
            let message = 'Comentarios actualizados';
            // await directusApi('GET', `items/mercadolibre_orders?filter[intelisis_movement][_eq]=${data.intelisis_movement}`)
            // if (start_date) params += `&filter[order_date][_between]=${start_date},${end_date}`;
            let current_year = new Date().getFullYear()  // returns the current year 16825
            let first_date = `${current_year}/01/01`;
            let last_date = `${current_year}/12/31`;

            await directusApi('GET', `items/prodelec_orders?filter[intelisis_movement][_eq]=${data.intelisis_movement}&filter[order_date][_between]=${first_date},${last_date}`)
                .then(async (res: any) => {
                    try {
                        if (res.data.data.length > 0) { //si el movimiento de intelisis está asignado a una orden
                            if (data.credit_note) { //notas de crédito
                                data.credit_note = (data.credit_note).toUpperCase();
                                let intelisis_skus: any = [];
                                let intelisisnc_skus: any = [];
                                await directusApi('GET', `custom/legacy-intelisis/validateMovement/${data.intelisis_movement}`).then(async res => {
                                    let articles_intelisis = res.data.data.movement;
                                    let articles_intelisis_formatter: any = [];
                                    articles_intelisis.forEach((intelisis_article: any) => {
                                        articles_intelisis_formatter.push({
                                            sku: intelisis_article.articulo,
                                            qty: intelisis_article.cantidad
                                        });
                                    });
                                    intelisis_skus = lodash.orderBy(await dispatch('formattingSkus', articles_intelisis_formatter), ['sku', 'qty'], ['asc', 'desc']);
                                });
                                await directusApi('GET', `custom/legacy-intelisis/validateCreditNote/${data.credit_note}`).then(async res => {
                                    let creditnote_intelisis = res.data.data.creditnote;
                                    let creditnote_intelisis_formatter: any = [];
                                    creditnote_intelisis.forEach(intelisis_article => {
                                        creditnote_intelisis_formatter.push({
                                            sku: intelisis_article.articulo,
                                            qty: intelisis_article.cantidad
                                        });
                                    });
                                    intelisisnc_skus = lodash.orderBy(await dispatch('formattingSkus', creditnote_intelisis_formatter), ['sku', 'qty'], ['asc', 'desc']);
                                });
                                if (lodash.isEqual(intelisis_skus, intelisisnc_skus)) {
                                    // await directusApi('PATCH', `items/mercadolibre_orders/${order_id}`, {
                                    await directusApi('PATCH', `items/prodelec_orders/${order_id}`, {
                                        credit_note: data.credit_note,
                                        updated_at: moment().format('YYYY/MM/DD H:mm:ss')
                                    })
                                        .then(async (res: any) => {
                                            message = 'Información actualizada';
                                        })
                                        .catch(err => {
                                            console.log(err);
                                        });
                                } else {
                                    data.vm.$bvToast.toast('La nota de crédito no coincide con la prefactura.', {
                                        title: `Checar información`,
                                        variant: 'danger',
                                        toaster: 'b-toaster-top-center',
                                        autoHideDelay: 5000,
                                    });
                                    message = 'Comentarios actualizados';
                                }
                            }
                            data.vm.$bvToast.toast('Una orden ya tiene asignado ese movimiento, actualizando solo los comentarios.', {
                                title: `Checar información`,
                                variant: 'danger',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            console.log('Una orden ya tiene asignado ese movimiento, actualizando solo los comentarios');
                            // await directusApi('PATCH', `items/mercadolibre_orders/${order_id}`, {
                            await directusApi('PATCH', `items/prodelec_orders/${order_id}`, {
                                comments: data.comments,
                                package_manager: data.package_manager,
                                shipment_status: data.shipment_status,
                                updated_at: moment().format('YYYY/MM/DD H:mm:ss')
                            })
                                .then(async (res: any) => {
                                    const apiResponse: ApiResponse = res.data.data;
                                    // console.log('putOne', { apiResponse });
                                    await commit('setActiveOrder', apiResponse);
                                })
                                .catch(err => {
                                    console.log(err);
                                })
                                .finally(() => {
                                    data.vm.$bvToast.toast(message, {
                                        title: `Orden actualizada`,
                                        variant: 'success',
                                        toaster: 'b-toaster-top-center',
                                        autoHideDelay: 5000,
                                    });
                                    // commit('toggleActiveOrderLoading', false);
                                });
                        } else {
                            await directusApi('GET', `custom/legacy-intelisis/validateMovement/${data.intelisis_movement}`).then(async res => {
                                let intelisis_total = 0;
                                let intelisis_qty = 0;
                                let movement: any = '';
                                let articles_intelisis = lodash.remove(res.data.data.movement, function (article: any) {
                                    movement = article;
                                    //console.log(article);
                                    //removing the servs
                                    article.cantidad = +article.cantidad;
                                    // intelisis_total += +article.precio * article.cantidad; //IT DOESN'T COUNT
                                    if (article.articulo == 'SERV2' || article.articulo == 'SERV10') {
                                    } else {
                                        // return article;
                                        intelisis_total += +article.precio * article.cantidad; // COUNT WITHOUT SERVS
                                        intelisis_qty += +article.cantidadreservada;
                                        return article;
                                    }
                                });
                                intelisis_total = intelisis_total + (intelisis_total * 0.16);
                                intelisis_total = +intelisis_total.toFixed(5);

                                //***********************************FORMATTING DATA OF SKU'S */
                                let articles_intelisis_formatter: any = [];
                                articles_intelisis.forEach(intelisis_article => {
                                    articles_intelisis_formatter.push({
                                        sku: intelisis_article.articulo,
                                        qty: intelisis_article.cantidad
                                    });
                                });
                                const intelisis_skus = lodash.orderBy(await dispatch('formattingSkus', articles_intelisis_formatter), ['sku', 'qty'], ['asc', 'desc']);

                                let formatSkusPublication: any = [];
                                let ml_qty = 0;
                                data.products.forEach((publication: any) => {
                                    let sales = publication.sales;
                                    if (publication.flag_products_order) { //validate that the publication is synchronized
                                        publication.linked_products.forEach((product: any) => {
                                            ml_qty += sales * product.qty;
                                            formatSkusPublication.push({
                                                // ...product,
                                                sku: product.id,
                                                qty: sales * product.qty
                                            });
                                        });
                                    } else {
                                        formatSkusPublication.push({
                                            // ...product,
                                            sku: false,
                                            qty: false
                                        });
                                    }
                                });

                                const publication_skus = lodash.orderBy(await dispatch('formattingSkus', formatSkusPublication), ['sku', 'qty'], ['asc', 'desc']);

                                console.log({ intelisis_skus });
                                console.log({ publication_skus });
                                // return false;

                                // console.log('VALIDANDO MOVIMIENTO Y REGRESANDO UN FALSE (TESTING PURPOSES)');
                                // return false;
                                //***********************************FORMATTING DATA OF SKU'S */
                                intelisis_total = await round(intelisis_total);
                                console.log({ intelisis_total });
                                console.log('comparative => ', data.balance);
                                console.log({ intelisis_qty });
                                console.log('comparative => ', ml_qty);
                                // console.log('data => ', res);

                                //let warehouse_intelisis = res.data.data.movement[0].almacen;
                                let warehouse_intelisis = movement.almacen;
                                //let client_intelisis = res.data.data.movement[0].cliente;
                                let client_intelisis = movement.cliente;
                                let flagWarehouse = false;
                                let flagClient = false;
                                let flagTotal = false;
                                let flagQtyReservado = false; //Check warehouse and client MLPR---------
                                if (warehouse_intelisis == 'FJ' && data.logistic_type == 'FULFILLMENT') {
                                    flagWarehouse = true;
                                } else if (warehouse_intelisis == '1ML' && data.logistic_type == 'REGULAR') {
                                    flagWarehouse = true;
                                } else if (warehouse_intelisis == '1ML' && data.logistic_type == 'M-E-COLECTA') {
                                    flagWarehouse = true;
                                } else if (warehouse_intelisis == '1ML' && data.logistic_type == 'A-ACORDAR') {
                                    flagWarehouse = true;
                                } else if (warehouse_intelisis == '1ML' && data.logistic_type == 'ML-PLACES') {
                                    flagWarehouse = true;
                                } else if (warehouse_intelisis == '1ML' && data.logistic_type != 'FULFILLMENT' && data.logistic_type != 'ecommerce') {
                                    flagWarehouse = true;
                                }
                                client_intelisis == 'MLPR' ? flagClient = true : flagClient = false;
                                intelisis_total = +intelisis_total.toFixed(2);
                                data.balance = +data.balance;
                                if (intelisis_total == data.balance ||
                                    intelisis_total == (data.balance + 0.01) ||
                                    intelisis_total == (data.balance - 0.01) ||
                                    intelisis_total == (data.balance + 0.02) ||
                                    intelisis_total == (data.balance + 0.02)) {//validation for == total $
                                    flagTotal = true;
                                } else {
                                    flagTotal = false;
                                }
                                // console.log({ flagTotal });
                                // let balance = +data.balance;
                                // console.log({ balance });



                                // intelisis_total == data.balance ? flagTotal = true : flagTotal = false; //validation for == total $

                                intelisis_qty == ml_qty ? flagQtyReservado = true : flagQtyReservado = false; //validation for qty's (reservado)

                                let flagSyncProduct = true;
                                data.products.forEach((element: any) => {
                                    // console.log(element);
                                    if (!element.flag_products_order) {
                                        flagSyncProduct = false;
                                    }
                                });
                                //PATCH orders without sync ************************************************
                                // if (!flagSyncProduct && flagWarehouse == true && flagClient == true) {
                                //     console.log(data.splitted_order);
                                //     await directusApi('PATCH', `items/mercadolibre_orders/${order_id}`, {
                                //         intelisis_movement: data.intelisis_movement,
                                //         comments: data.comments,
                                //         package_manager: data.package_manager
                                //     })
                                //         .then(async (res: any) => {
                                //             const apiResponse: ApiResponse = res.data.data;
                                //             await commit('setActiveOrder', apiResponse);
                                //             // console.log('putOne', { apiResponse });
                                //         })
                                //         .catch(err => {
                                //             console.log(err);
                                //         })
                                //         .finally(async () => {
                                //             if (data.splitted_order) { //validating and updating splitted orders
                                //                 await data.splitted_order.forEach(async (splitted: any) => {
                                //                     await directusApi('PATCH', `items/mercadolibre_orders/${splitted}`, { intelisis_movement: data.intelisis_movement })
                                //                         .then(async (res: any) => {
                                //                             console.log('splitted order updated => ', res.data.data.id);
                                //                         })
                                //                         .catch(err => {
                                //                             console.log(err);
                                //                         })
                                //                 });
                                //             }
                                //             data.vm.$bvToast.toast('Alguna publicación no esta sincronizada', {
                                //                 title: `Actualizada (Atención)`,
                                //                 variant: 'warning',
                                //                 toaster: 'b-toaster-top-center',
                                //                 autoHideDelay: 5000,
                                //             });
                                //             // commit('toggleActiveOrderLoading', false);
                                //         });
                                //     console.log('Alguna publicación no esta sincronizada, requiere autorización de un supervisor');
                                //     // commit('toggleActiveOrderLoading', false);
                                // }
                                // console.log({ flagWarehouse });
                                // console.log({ flagClient });
                                // console.log({ flagTotal });
                                // console.log({ flagQtyReservado });
                                if (flagWarehouse == true && flagClient == true && flagTotal == true && flagQtyReservado == true) {
                                    if (lodash.isEqual(intelisis_skus, publication_skus) && intelisis_skus.length > 0) { //validate if skus are equals
                                        // console.log('VALIDATION***', articles_intelisis, ' COMPARE ==> ', data.products);
                                        // await directusApi('PATCH', `items/mercadolibre_orders/${order_id}`, {
                                        await directusApi('PATCH', `items/prodelec_orders/${order_id}`, {
                                            intelisis_movement: data.intelisis_movement,
                                            comments: data.comments,
                                            package_manager: data.package_manager,
                                            updated_at: moment().format('YYYY/MM/DD H:mm:ss')
                                        })
                                            .then(async (res: any) => {
                                                const apiResponse: ApiResponse = res.data.data;
                                                await commit('setActiveOrder', apiResponse);
                                                // console.log('putOne', { apiResponse });
                                            })
                                            .catch(err => {
                                                console.log(err);
                                            })
                                            .finally(async () => {
                                                if (data.splitted_order) { //validating and updating splitted orders
                                                    await data.splitted_order.forEach(async (splitted: any) => {
                                                        // await directusApi('PATCH', `items/mercadolibre_orders/${splitted}`, { intelisis_movement: data.intelisis_movement })
                                                        await directusApi('PATCH', `items/prodelec_orders/${splitted}`, {
                                                            intelisis_movement: data.intelisis_movement,
                                                            updated_at: moment().format('YYYY/MM/DD H:mm:ss')
                                                        })
                                                            .then(async (res: any) => {
                                                                console.log('splitted order updated => ', res.data.data.id);
                                                            })
                                                            .catch(err => {
                                                                console.log(err);
                                                            })
                                                    });
                                                }
                                                data.vm.$bvToast.toast('Orden actualizada correctamente', {
                                                    title: `Actualizada`,
                                                    variant: 'success',
                                                    toaster: 'b-toaster-top-center',
                                                    autoHideDelay: 5000,
                                                });
                                                // commit('toggleActiveOrderLoading', false);
                                            });
                                        console.log('Venta validada con exito!!!');
                                    } else { //updating only comments (skus isn't equal)
                                        // await directusApi('PATCH', `items/mercadolibre_orders/${order_id}`, {
                                        await directusApi('PATCH', `items/prodelec_orders/${order_id}`, {
                                            comments: data.comments,
                                            package_manager: data.package_manager,
                                            updated_at: moment().format('YYYY/MM/DD H:mm:ss')
                                        })
                                            .then(async (res: any) => {
                                                const apiResponse: ApiResponse = res.data.data;
                                                // console.log('putOne', { apiResponse });
                                                await commit('setActiveOrder', apiResponse);
                                            })
                                            .catch(err => {
                                                console.log(err);
                                            })
                                            .finally(() => {
                                                data.vm.$bvToast.toast('La prefactura no existe en intelisis o los productos no coinciden', {
                                                    // data.vm.$bvToast.toast('Comentarios actualizados', {
                                                    title: `Orden actualizada`,
                                                    variant: 'danger',
                                                    toaster: 'b-toaster-top-center',
                                                    autoHideDelay: 5000,
                                                });
                                                // commit('toggleActiveOrderLoading', false);
                                            });
                                        console.log('La prefactura no existe en intelisis o los productos no coinciden');
                                        // commit('toggleActiveOrderLoading', false);
                                    }
                                } else {

                                    data.vm.$bvToast.toast('Lo sentimos, las prefacturas no coinciden con las restricciones por almacén', {
                                        // data.vm.$bvToast.toast('Las restricciones de almacenes no se han cumplido', {
                                        title: `Orden no actualizada`,
                                        variant: 'warning',
                                        toaster: 'b-toaster-top-center',
                                        autoHideDelay: 5000,
                                    });
                                    console.log('Lo sentimos, las prefacturas no coinciden con las restricciones por almacén')
                                }
                            });
                        }
                        // order_id = res.data[0].id
                    } catch (error) {
                        data.vm.$bvToast.toast('Revisar order', {
                            title: `No actualizada`,
                            variant: 'warning',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 5000,
                        });
                        console.log('order not found to update', error);
                        throw error;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            // await directusApi('PATCH', `items/mercadolibre_orders/${order_id}`, {
            await directusApi('PATCH', `items/prodelec_orders/${order_id}`, {
                comments: data.comments,
                package_manager: data.package_manager,
                //  shipment_status: data.shipment_status,
                updated_at: moment().format('YYYY/MM/DD H:mm:ss')
            })
                .then(async (res: any) => {
                    const apiResponse: ApiResponse = res.data.data;

                    // try {
                    //     await directusApi('POST', 'custom/payments/sendEmail', apiResponse);
                    //     console.log('Correo enviado correctamente para el estado:');
                    // } catch (emailError) {
                    //     console.error('Error al enviar correo:', emailError);
                    // }

                    await commit('setActiveOrder', apiResponse);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    // data.vm.$bvModal.msgBoxOk('message',{noCloseOnBackdrop: true});
                    data.vm.$bvToast.toast('Comentarios actualizados (sin movimiento)', {
                        title: `Orden actualizada`,
                        variant: 'success',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                    // commit('toggleActiveOrderLoading', false);
                });
            console.log('Actualizando solo los comentarios');
            // commit('toggleActiveOrderLoading', false);
        }
    },

    async putOneManager({ _, commit, dispatch }: any, data: any) {
        commit('toggleallOrdersLoading', true);
        // await directusApi('PATCH', `items/mercadolibre_orders/${data.id}`, {
        await directusApi('PATCH', `items/prodelec_orders/${data.id}`, {
            package_manager: data.package_manager,
            updated_at: moment().format('YYYY/MM/DD H:mm:ss')
        })
            .then(async (res: any) => {
                const apiResponse: ApiResponse = res.data.data;
                await commit('setActiveOrder', apiResponse);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                data.vm.$bvToast.toast('Responsable del paquete actualizado', {
                    title: `Orden actualizada`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            });
        commit('toggleallOrdersLoading', false);
    },

    async getOne({ _, commit }: any, { id }: any) {
        commit('toggleActiveOrderLoading', true);
        await directusApi('GET', `items/prodelec_orders/${id}?fields=*.*,order_user.*`)
            .then(async res => {
                const order = res.data.data;
                await fillOrderStore(order);
                commit('setActiveOrder', order);
            })
            .catch(err => {
                console.log(err);
            });
    },

    async toggleOrderFalse({ _, commit }: any) {
        commit('toggleActiveOrderLoading', false);
    },
    async getAll(
        { _, commit }: any,
        {
            search,
            page,
            sortName,
            sortValue,
            filterLogisticType,
            filterStatus,
            order_status_filter,
            shipment_status_filter,
            claim_return_status_filter,
            day_filter,
            assigned_move_filter,
            start_date,
            end_date,
        }: any
    ) {
        commit('toggleallOrdersLoading', true);

        let limit = 20;
        let params = '';
        if (search) {
            if (search.includes('MLM') || search.includes('mlm')) { //search by mlPost
                params += `&filter[publications_id][_contains]=${search}`;
            } else if (search.includes('V') || search.includes('v')) { //search by another order id
                search = search.substring(1); //removing first element 'v'
                params += `&filter[related_order_id][_contains]=${search}`;
            } else {
                if (search * 0 == 0) { //search by order (only numbers)
                    if (search.length < 5) { //less than 5 search by intelisis_movement
                        params += `&filter[intelisis_movement][_contains]=${search}`;
                    } else {
                        params += `&filter[id][_contains]=${search}`;
                    }
                } else {
                    const sku = encodeURIComponent(search.trim());
                    params += `&filter[_or][0][products_id][_contains]=${sku}`;
                    params += `&filter[_or][1][order_items][_contains]=${sku}`;
                }
            }
        }
        if (filterLogisticType) params += `&filter[logistic_type][_eq]=${filterLogisticType}`;
        if (order_status_filter) params += `&filter[order_status][_contains]=${order_status_filter}`;
        if (shipment_status_filter) params += `&filter[shipment_status][_contains]=${shipment_status_filter}`;
        if (claim_return_status_filter) {
            if (claim_return_status_filter == 'to_send') {
                // params += `filter[active_status][_contains]=ready_to_print`;
                params += `&filter[active_status][_in]=ready_to_print,ready_for_pickup`;
            } else if (claim_return_status_filter == 'shipped') {
                params += `&filter[active_status][_in]=shipped,receiver_absent,picked_up,out_for_delivery,delayed,in_hub,authorized_by_carrier,ready_for_pickup`;
            } else {
                params += `&search=${claim_return_status_filter}&filter[intelisis_movement][_ncontains]=null`;
            }
        }
        // if (claim_return_status_filter) params += `&search=${claim_return_status_filter}&filter[intelisis_movement][_ncontains]=null`;
        if (assigned_move_filter) {
            if (assigned_move_filter == 'unassigned') {
                params += `&filter[intelisis_movement][_contains]=null`;
            } else {
                params += `&filter[intelisis_movement][_ncontains]=null`;
            }
        }
        if (start_date) params += `&filter[order_date][_between]=${start_date},${end_date}`;

        params += `&sort=-order_date&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=20&offset=${(page - 1) * limit}`;

        // let endpoint = `items/mercadolibre_orders?${params}`;
        let endpoint = `items/prodelec_orders?${params}`;

        await directusApi('GET', endpoint)
            .then(async res => {
                // console.log({ orders: res.data.data });
                await directusApi('GET', 'custom/legacy-mercadolibre/schedule')
                    .then(res => {
                        commit('setOrdersSchedule', res.data.schedule);
                    }).catch(err => {
                        console.log('Error al consultar información de los horarios: ', err);
                    });
                let mlpublications = [];
                let contOrder = 0;
                // res.data.data = lodash.remove(res.data.data, function (order: any) {
                //     if (order.logistic_type == 'ecommerce') {
                //         return order.status == 'procesando_en_prodelec';
                //     } else {
                //         return order;
                //     }
                // });
                await asyncForEach(res.data.data, async (order: any) => {
                    await fillOrderStore(order);
                    //********** validating the origin of the order (logistic_type)
                    if (order.logistic_type == 'cotizador' || order.logistic_type == 'ecommerce') {
                        order.orderPublications = [];
                        return false;
                    }

                    if (order.ml_publications) { // validation to info from notification (added previously)
                        // console.log('new method ', order.id);
                        order.orderPublications = order.ml_publications;
                    } else { // old method using request (GET)
                        console.log('old method ', order.id);
                        await asyncForEach(order.order_items, async (item: any) => {
                            await directusApi('GET', `custom/legacy-mercadolibre/publicationMl/${item.item.id}`).then(async (publication: any) => {
                                let skuInfo = publication.data.attributes.find((att: any) => att.id == 'SELLER_SKU')
                                    ? publication.data.attributes.find((att: any) => att.id == 'SELLER_SKU').value_name
                                    : item.item.seller_sku;
                                mlpublications.push({
                                    id: publication.data.id,
                                    title: publication.data.title,
                                    price: publication.data.original_price ? publication.data.original_price : publication.data.price,
                                    sku: skuInfo,
                                    image: publication.data.pictures[0].url,
                                    sales: item.quantity,
                                });
                            }).catch((err) => console.log(err));
                        });
                        order.orderPublications = mlpublications;
                    }
                    mlpublications = [];
                    contOrder++;
                    // if (order.logistic_type == 'ecommerce') {
                    //     res.data.data = lodash.remove(res.data.data, function (n: any) {
                    //         return order.send_email.order_successful == true;
                    //     })
                    // }
                });
                // console.log({ contOrder });
                // console.log({ mlpublications });

                commit('setAllOrders', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleallOrdersLoading', false);
            });
    },
    async toggleAllOrdersFalse({ _, commit }: any) {
        commit('toggleallOrdersLoading', false);
    },
    async printLabel({ _, commit, dispatch }: any, { order_id, store }: any) {
        if (store == 'prodelec') { //print label from 
            await directusApi('GET', `custom/legacy-mercadolibre/prodelec/orders/shipment_label/${order_id}`)
                .then(async res => {
                    window.open(res.data, '_blank');
                    await dispatch('getOne', { id: order_id });
                    await directusApi('PATCH', `items/prodelec_orders/${order_id}`, {
                        status: 'shipped'
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            await directusApi('GET', `custom/legacy-mercadolibre/orders/shipment_label/${order_id}`)
                .then(async res => {
                    window.open(res.data, '_blank');
                    await dispatch('getOne', { id: order_id });
                    await directusApi('PATCH', `items/prodelec_orders/${order_id}`, {
                        status: 'shipped'
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    async sendPackage({ _, commit, dispatch }: any) {
        console.log('enviando el paquete... :D');
        await directusApi('POST', `custom/legacy-intelisis/create_invoice`, {
            data: 'any data for dev purposes'
        })
            .then(async res => {
                console.log('mail sended');

            })
            .catch(err => {
                console.log(err);
            });
    },
    async formattingSkus({ _, commit }: any, arraySkus: any) {
        return arraySkus.reduce((accumulator, actualValue) => {
            const existElement = accumulator.find(product => product.sku === actualValue.sku);
            if (existElement) {
                return accumulator.map((product) => {
                    if (product.sku === actualValue.sku) {
                        return {
                            ...product,
                            qty: product.qty + actualValue.qty
                        }
                    }

                    return product;
                });
            }

            return [...accumulator, actualValue];
        }, []);
    },
    async monthlySummaryOrders({ _, commit }: any, data: any) {
        commit('monthlySummaryLoading', true);

        const dateSlash = data.date;
        const dateDash = data.date.replace(/\//g, '-');

        const filter = {
            _or: [
                { order_date: { _contains: dateSlash } },
                { order_date: { _contains: dateDash } }
            ]
        };

        const params = new URLSearchParams({
            filter: JSON.stringify(filter),
            meta: 'filter_count',
            limit: '-1',
        }).toString();

        let endpoint = `items/prodelec_orders?${params}`;
        let monthly_orders = [];
        let total = 0;
        let orderRes: Array<{}> = [];
        let newOrder: any;
        let resFinal: Array<{ id_sale: string, sku: string, sold_qty: number }> = [];
        let maxLength: any;
        await directusApi('GET', endpoint)
            .then(async res => {
                total = res.data.meta.filter_count;
                await asyncForEach(res.data.data, async (order: any) => {
                    // console.log({ order });

                    // ****************** START Getting active status by order
                    let status = order.status.replace(/ /g, '').split(',');
                    let status_order: any = [];
                    if (order.order_status == 'paid' || order.order_status == 'success') {
                        let clearStatus: any = lodash.remove(status, function (n) {
                            return n != 'null' && n != 'paid' && n != 'undefined';
                        });
                        clearStatus = clearStatus[clearStatus.length - 1];
                        status_order = validateStatusOrders(clearStatus, order.order_status);
                    } else if (order.order_status == 'cancelled') {
                        let clearStatus: any = lodash.remove(status, function (n) {
                            return n != 'null' && n != 'undefined' && n != 'pack_splitted';
                        });
                        clearStatus = clearStatus[clearStatus.length - 1];
                        status_order = validateStatusOrders(clearStatus, order.order_status);
                    } else {
                        if (order.logistic_type == 'ecommerce') {
                            status_order = validateStatusOrders('procesando_en_prodelec', order.order_status);
                        }
                        console.log('Check case of order status');
                    }
                    // ****************** END

                    // ****************** START Getting charges by order
                    let quantity_item: any = 0;
                    let sale_fee: any = 0;
                    let saleDetail: any = [];
                    let totalOrder: any = order.balance; // "Total de la venta"
                    let amountOrder: any = 0; // "Total de los Productos"
                    let shipmentCostOrder: any = 0; // "Costo de envío a cargo de Mercado Envíos"
                    let shippingCostBuyer: any = 0; // "Costo de envío a cargo del comprador"
                    if (order.logistic_type != 'ecommerce' && order.logistic_type != 'cotizador') {
                        if (order.ml_publications) {
                            await asyncForEach(order.products_order, async (product: any) => {
                                let coincidence_sale_fee = lodash.find(order.sale_detail, function (o: any) {
                                    return o.title == product.title;
                                });
                                sale_fee += +coincidence_sale_fee.sale_fee;
                            });
                            totalOrder = totalOrder - sale_fee;
                        } else {
                            await asyncForEach(order.order_items, async (item: any) => {
                                quantity_item = item.quantity;
                                sale_fee = item.sale_fee;
                                await directusApi('GET', `custom/legacy-mercadolibre/publications/${item.id}`)
                                    .then(async (res: any) => {
                                        if (res.data.linked_products.length > 0) {
                                            let charges: any = (sale_fee * quantity_item).toFixed(2);
                                            saleDetail.push({
                                                sale_fee: charges,
                                            });
                                            totalOrder = totalOrder - charges;
                                        } else {
                                            if (res.data.variations[0] && res.data.variations[0].linked_products.length > 0) {
                                                let charges: any = (sale_fee * quantity_item).toFixed(2);
                                                saleDetail.push({
                                                    sale_fee: charges,
                                                });
                                                totalOrder = totalOrder - charges;
                                            } else {
                                                let charges: any = (sale_fee * quantity_item).toFixed(2);
                                                saleDetail.push({
                                                    sale_fee: charges,
                                                });
                                                totalOrder = totalOrder - charges;
                                            }
                                        }
                                    })
                                    .catch((err) => {
                                        console.log('post not found');
                                    });
                            });
                        }
                        order.total_amount > 0 ? (amountOrder = parseFloat(order.total_amount).toFixed(2)) : amountOrder;
                        order.shipping_cost > 0
                            ? (shipmentCostOrder = parseFloat(order.shipping_cost).toFixed(2))
                            : shipmentCostOrder;
                        order.shipping_cost_buyer > 0
                            ? (shippingCostBuyer = parseFloat(order.shipping_cost_buyer).toFixed(2))
                            : shippingCostBuyer;
                        totalOrder = totalOrder - shipmentCostOrder;
                        totalOrder = parseFloat(totalOrder).toFixed(2);
                    }
                    else {
                        if (order.payment_info.payment_total > 1000) {
                            shipmentCostOrder = order.shipping_cost_total;
                        } else {
                            shippingCostBuyer = order.shipping_cost_total;
                        }
                        totalOrder = order.payment_info.payment_total;
                    }

                    if (saleDetail.length > 0) {
                        sale_fee = 0;
                        await asyncForEach(saleDetail, async (detail: any) => {
                            sale_fee += +detail.sale_fee
                        });
                    }

                    // console.log(order);

                    // if (order.id === '2000006600467039') {
                    // //     console.log("entra");
                    //     console.log(order);

                    // if (order.id === '2000009734512918') {


                    if (order.products_order && order.products_order.length > 0) {
                        for (const ord of order.products_order) {
                            const sales = ord.sales;
                            newOrder = {
                                id: order.id,
                                id_publication: ord.id_publication,
                                sales: sales,
                                skus: [] as Array<{}>
                            };

                            if (ord.linked_products && ord.linked_products.length > 0) {
                                for (const product of ord.linked_products) {
                                    if (order.id === newOrder.id) {
                                        newOrder.skus.push({
                                            id_sale: newOrder.id,
                                            id_post: newOrder.id_publication,
                                            sku: product.id,
                                            qty: parseInt(product.qty),
                                            sold_qty: newOrder.sales * parseInt(product.qty)
                                        });
                                    }

                                    orderRes.push(newOrder); //todos las publicaciones existentes con su id de venta
                                }
                            }
                        }
                    } else {
                        if (order.order_items && order.order_items.length > 0) {
                            let newOrder = {
                                id: order.id,
                                id_publication: null,
                                sales: 1,
                                skus: [] as Array<{}>,
                            };

                            for (const product of order.order_items) {
                                newOrder.skus.push({
                                    id_sale: order.id,
                                    id_post: null,
                                    sku: product.id,
                                    qty: parseInt(product.quantity),
                                    sold_qty: parseInt(product.quantity)
                                });
                            }

                            orderRes.push(newOrder);
                        }
                    }

                    // combinar los skus si tiene el mismo numero de venta
                    const combined = orderRes.reduce((acc: any, current: any) => {
                        const existing = acc.find(item => item.id === current.id);
                        if (existing) {
                            existing.skus = [...existing.skus, ...current.skus];
                        } else {
                            acc.push({ ...current });
                        }
                        return acc;
                    }, []);


                    // Función para eliminar duplicados dentro de 'skus' por propiedades específicas
                    const removeDuplicateSkus = (array) => {
                        return array.filter((item, index, self) =>
                            index === self.findIndex((t) => (
                                t.sku === item.sku &&
                                t.qty === item.qty &&
                                t.sold_qty === item.sold_qty
                            ))
                        );
                    };

                    // Iterar sobre cada objeto en 'data' y limpiar duplicados en 'skus'
                    const cleanedData = combined.map((item) => {
                        return {
                            ...item,
                            skus: removeDuplicateSkus(item.skus)
                        };
                    });

                    // Encontrar la longitud máxima del array `skus`
                    maxLength = Math.max(...cleanedData.map(item => item.skus.length));

                    const allSkus = cleanedData.flatMap((producto: any) => producto.skus || []); // Aseguramos que si `skus` no existe, se usa un array vacío

                    // sumar los sold_qty cuando el id de la venta y el sku se repitan
                    const aggregatedSkus = allSkus.reduce((acc, item) => {
                        const key = `${item.id_sale}-${item.sku}`;

                        if (acc[key]) {
                            acc[key].sold_qty += item.sold_qty;
                        } else {
                            acc[key] = { ...item };
                        }

                        return acc;
                    }, {});

                    resFinal = Object.values(aggregatedSkus);

                    let store = '';
                    if (order.store === 'prodelec') {
                        store = 'Meli1'
                    } else if (order.store === null && order.logistic_type == 'ecommerce') {
                        store = 'Ecommerce'
                    } else {
                        store = 'ProdelecOficial'
                    }

                    // ****************** START Structure for summary
                    monthly_orders.push({
                        id: order.id,
                        date: order.order_date,
                        status: status_order.status,
                        store: store,
                        skus: order.products_id,
                        total_products: amountOrder,
                        total_order: totalOrder,
                        shipment_cost_order: shipmentCostOrder,
                        shipment_cost_buyer: shippingCostBuyer,
                        charges: sale_fee,
                        intelisis_movement: order.intelisis_movement,
                        comments: order.comments,
                        qtySold: resFinal
                    })
                    // ****************** END
                });
                if (total == 0) {
                    data.vm.$bvToast.toast('Lo sentimos, no se encuentran registros de la fecha seleccionada.', {
                        title: `Sin registros`,
                        variant: 'warning',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                } else {
                    // Excel in progress
                    let html = `<tr>
                    <td>No. de venta</td>
                    <td>No. de prefactura</td>
                    <td>Fecha</td>
                    <td>Estatus</td>
                    <td>Tienda</td>
                    <td>Sku(s)</td>
                    <td>Productos</td>
                    <td>Envío</td>
                    <td>Envío a cargo del comprador</td>
                    <td>Cargos</td>
                    <td>Total</td>
                    <td>Comentarios</td>`;

                    for (let i = 1; i <= maxLength; i++) {
                        html += `<td>Sku ${i}</td>
                                <td>Qty ${i}</td>`;
                    }

                    html += `</tr>`;
                    // html = this.activeQuotation.products.reduce((acc: any, val: any) => {
                    //     return val.sku ? acc + `<tr><td>${val.sku}</td><td>${val.qty}</td></tr>` : '';
                    // }, '');
                    await asyncForEach(monthly_orders, async (order: any) => {
                        html += `<tr>
                        <td>'${order.id}</td>
                        <td>${order.intelisis_movement}</td>
                        <td>${order.date}</td>
                        <td>${order.status}</td>
                        <td>${order.store}</td>
                        <td>${order.skus}</td>
                        <td>${order.total_products}</td>
                        <td>${order.shipment_cost_order}</td>
                        <td>${order.shipment_cost_buyer}</td>
                        <td>${order.charges}</td>
                        <td>${order.total_order}</td>
                        <td>${order.comments}</td>`

                        let hasProducts = false;
                        for (let i = 0; i < resFinal.length; i++) {
                            if (String(order.id) === String(resFinal[i].id_sale)) {
                                hasProducts = true;
                                // Agregar los SKU y Qty correspondientes
                                html += `
                                    <td>${resFinal[i].sku || ''}</td>
                                    <td>${resFinal[i].sold_qty || ''}</td>
                                `;
                            }
                        }

                        html += `</tr>`;
                    });
                    const wb: XLSX.WorkBook = XLSX.read(`<table>${html}</table>`, {
                        type: 'string',
                    });
                    XLSX.writeFile(wb, `${data.date}summary.xls`);
                }
                // console.log({ total });
                // console.log({ monthly_orders });

                commit('monthlySummaryLoading', false);
            })
            .catch(err => {
                console.log(err);
            });
    },

    async monthlySummaryClients({ _, commit }: any, data: any) {
        console.log("entra", data);

        commit('monthlySummaryLoading', true);
        let params = '';
        params += `&filter[order_date][_contains]=${data.date}`;
        params += `&meta=filter_count&limit=-1`;
        let endpoint = `items/prodelec_orders?${params}`;
        await directusApi('GET', endpoint)
            .then(async res => {
                let dataR = res.data.data;
                let ids = dataR.map(item => item.id);
                await directusApi('POST', `custom/legacy-mercadolibre/dataClients`, ids)
                    .then(res => {
                        const ordersData = res.data.ordersOther.concat(res.data.ordersProdelec);
                        if (ordersData.length === 0) {
                            data.vm.$bvToast.toast('Lo sentimos, no se encuentran registros de la fecha seleccionada.', {
                                title: `Sin registros`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        } else {
                            const purchaseFrequencyMap = {};
                            ordersData.forEach(order => {
                                const buyerId = order.buyer.id.toString();
                                if (purchaseFrequencyMap[buyerId]) {
                                    purchaseFrequencyMap[buyerId] += 1;
                                } else {
                                    purchaseFrequencyMap[buyerId] = 1;
                                }
                            });

                            const monthly_clients = ordersData.map(order => {
                                const buyerId = order.buyer.id.toString();
                                return {
                                    id: order.id,
                                    date_created: order.date_created,
                                    store: order.store,
                                    buyer_id: buyerId,
                                    buyer_first_name: order.buyer.first_name,
                                    buyer_last_name: order.buyer.last_name,
                                    buyer_nickname: order.buyer.nickname,
                                    purchase_frequency: purchaseFrequencyMap[buyerId]
                                };
                            });


                            // // Excel in progress
                            let html = `<tr>
                            <td>No. de venta</td>
                            <td>Fecha</td>
                            <td>Tienda</td>
                            <td>No. de cliente</td>
                            <td>Nombre del cliente</td>
                            <td>Apellido</td>
                            <td>Nickname</td>
                            <td>Frecuencia de compra</td>
                            </tr>`;

                            monthly_clients.forEach(order => {
                                html += `<tr>
                                <td>'${order.id}</td>
                                <td>${order.date_created}</td>
                                <td>${order.store}</td>
                                <td>'${order.buyer_id}</td>
                                <td>${order.buyer_first_name}</td>
                                <td>${order.buyer_last_name}</td>
                                <td>${order.buyer_nickname}</td>
                                <td>${order.purchase_frequency}</td>
                                </tr>`;
                            });
                            const wb: XLSX.WorkBook = XLSX.read(`<table>${html}</table>`, {
                                type: 'string',
                            });
                            XLSX.writeFile(wb, `${data.date}summary.xls`);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
                commit('monthlySummaryLoading', false);
            })
            .catch(err => {
                console.log(err);
            });
    },

    async setStatus({ _, commit, dispatch }: any, data: any) {
        commit('toggleActiveOrderLoading', true);
        let payload = {
            date: data.current_date,
            email: data.email,
            order_id: data.order_id,
            user_id: data.user_id,
            username: data.user_name
        };
        await directusApi('PATCH', `items/prodelec_orders/${data.order_id}`, {
            manual_delivered: payload
        }).then(async (res: any) => {
            let invoice_link = `https://www.prodelec.mx/factura/generar/${data.order_id}`;
            navigator.clipboard.writeText(invoice_link);
            data.vm.$bvToast.toast('Tienes 24 hrs. para generar la factura, el enlace de facturación se ha generado y copiado exitosamente.', {
                title: `Orden actualizada`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 8000,
            });
            commit('toggleActiveOrderLoading', false);
        }).catch(err => {
            console.log(err);
        });
    },
    async disableInvoice({ _, commit, dispatch }: any, data: any) {
        commit('toggleActiveOrderLoading', true);
        await directusApi('PATCH', `items/prodelec_orders/${data.order_id}`, {
            invoice_disabled: true
        }).then(async (res: any) => {
            data.vm.$bvToast.toast('El proceso para facturar esta venta se ha deshabilitado.', {
                title: `Orden actualizada`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 8000,
            });
            commit('toggleActiveOrderLoading', false);
        }).catch(err => {
            console.log(err);
        });
    },
    async syncStatus({ _, commit, dispatch }: any, { main_id, order_id, store, vm }: any) {
        if (store) { //validation for Meli Prodelec
            await directusApi('GET', `custom/legacy-mercadolibre/prodelec/orders/syncInfo/${order_id}`)
                .then(async res => {
                    if (res.data) {
                        vm.$bvToast.toast('Se ha sincronizado el estatus de la orden', {
                            title: `Orden actualizada`,
                            variant: 'success',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 8000,
                        });
                        await dispatch('getOne', { id: main_id });
                    } else {
                        vm.$bvToast.toast('Lo sentimos ocurrio un error, intenta de nuevo más tarde', {
                            title: `Orden no actualizada`,
                            variant: 'danger',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 8000,
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        } else { // validation for Meli Official Stores
            await directusApi('GET', `custom/legacy-mercadolibre/orders/syncInfo/${order_id}`)
                .then(async res => {
                    if (res.data) {
                        vm.$bvToast.toast('Se ha sincronizado el estatus de la orden', {
                            title: `Orden actualizada`,
                            variant: 'success',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 8000,
                        });
                        await dispatch('getOne', { id: main_id });
                    } else {
                        vm.$bvToast.toast('Lo sentimos ocurrio un error, intenta de nuevo más tarde', {
                            title: `Orden no actualizada`,
                            variant: 'danger',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 8000,
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }

    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
